/* Screen between the identity selection and the app: /api/me in flight, denied, or failed.
 * Restyled with the prototype design system (lime brand card, black buttons). */

import type { ApiError } from '../api/client'
import { Icon } from '../ui/icons'

export function SsoLanding({
  identityHint,
  status,
  error,
  onRetry,
  onSignIn,
}: {
  /** The account being signed in, shown so a rejected user can see *which* account was used. */
  identityHint: string | null
  status: 'authenticating' | 'denied' | 'error'
  error?: ApiError | null
  onRetry: () => void
  onSignIn: () => void
}) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        padding: 18,
      }}
    >
      <div className="card" style={{ width: '100%', maxWidth: 460, marginBottom: 0 }}>
        <div
          style={{
            background: 'var(--ink)',
            padding: '18px 22px',
            display: 'flex',
            alignItems: 'center',
            gap: 14,
          }}
        >
          <img src="/kbl-logo-mark.png" alt="Kirloskar Brothers Limited" style={{ height: 30 }} />
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, textTransform: 'uppercase', color: '#fff' }}>
              Kirloskar Brothers Limited
            </div>
            <div style={{ fontSize: 10.5, color: '#8FA0B0' }}>Internal AI Assistant</div>
          </div>
        </div>

        <div className="card-b" style={{ padding: 26 }}>
          {status === 'authenticating' && (
            <>
              <h3 style={{ marginBottom: 8 }}>
                Signing you in{identityHint ? <> as {identityHint}</> : null}…
              </h3>
              <div className="sso-detect">
                <span className="spinner dark" />
                <span>Authenticating with Microsoft Entra ID</span>
              </div>
            </>
          )}

          {status === 'denied' && (
            <>
              <h3 style={{ marginBottom: 10 }}>
                Your account doesn&rsquo;t have access to the Internal AI Assistant.
              </h3>
              <div className="alert a-warn">
                <Icon name="lock" size={18} />
                <div>
                  Access is granted through Azure AD groups — contact IT Helpdesk.
                  {identityHint && (
                    <>
                      {' '}
                      Signed in as <strong>{identityHint}</strong>.
                    </>
                  )}
                </div>
              </div>
              <button type="button" className="btn btn-block" onClick={onSignIn}>
                Sign in with a different account
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <h3 style={{ marginBottom: 10 }}>We couldn&rsquo;t reach the sign-in service.</h3>
              <div className="alert a-danger">
                <Icon name="alert" size={18} />
                <div>{error?.message ?? 'Microsoft Entra ID did not respond.'}</div>
              </div>
              <div style={{ display: 'flex', gap: 9, flexWrap: 'wrap' }}>
                <button type="button" className="btn btn-lime" onClick={onRetry}>
                  Try again
                </button>
                <a className="btn btn-ghost" href="/" style={{ textDecoration: 'none' }}>
                  Back to the intranet portal
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
